import Integrations from '@/modules/integrations/types'

let integrationsTypes = {}
let integrationNames = {}
for (const [key, value] of Object.entries(Integrations)) {
  integrationsTypes[key] = value.type
  integrationNames[key] = value.title
}

integrationsTypes = Object.freeze(integrationsTypes)

export { integrationsTypes, integrationNames }



// WEBPACK FOOTER //
// ./src/modules/integrations/enum/IntegrationsEnum.js